/* =================== TABS =================== */
jQuery(document).ready(function ($) {
  $(".tabs-abas-materias li").on("click", function () {
    var tabId = $(this).data("tab");

    $(".tabs-abas-materias li").removeClass("active");
    $(".tab-content-assuntos").removeClass("active");

    $("#" + tabId).addClass("active");
    $(this).addClass("active");
  });
});
